import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { EmailClipModule } from '@platform-frontend/account-ui';
import { ColorModule, icoAcademic, IconsModule, LinkModule, SafeUrlModule, TabSelectableModule } from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { WebCheckoutHeaderComponent } from './web-checkout-header/web-checkout-header.component';

@NgModule({
  declarations: [WebCheckoutHeaderComponent],
  imports: [
    ColorModule,
    CommonModule,
    EmailClipModule,
    IconsModule.withIcons(icoAcademic),
    LinkModule,
    RouterExtensionsModule,
    RouterModule,
    SafeUrlModule,
    TabSelectableModule,
    TranslocoModule
  ],
  exports: [WebCheckoutHeaderComponent]
})
export class HeaderModule {}
